import { CondominiumType, PropertyType } from '@models/matter';

export const propertyTypesResidential = [
	{ label: 'House', value: PropertyType.HOME, name: 'House' },
	{ label: 'Condo', value: PropertyType.CONDO, name: 'Condo' },
	{ label: 'Vacant land', value: PropertyType.VACANT, name: 'Vacant land' },
	{ label: 'Farm land', value: PropertyType.FARM_LAND, name: 'Farm land' },
	{
		label: 'Mobile home',
		value: PropertyType.MOBILE_HOME,
		name: 'Mobile home',
	},
	{ label: 'Other', value: PropertyType.OTHER, name: 'Other' },
] as const;

export const propertyTypesCommercial = [
	{ label: 'Building', value: PropertyType.BUILDING, name: 'Building' },
	{ label: 'Condo', value: PropertyType.CONDO, name: 'Condo' },
	{ label: 'Vacant land', value: PropertyType.VACANT, name: 'Vacant land' },
	{ label: 'Farm land', value: PropertyType.FARM_LAND, name: 'Farm land' },
	{ label: 'Other', value: PropertyType.OTHER, name: 'Other' },
] as const;

export const condoTypes = [
	{ label: 'Standard', value: CondominiumType.STANDARD, name: 'Standard' },
	{ label: 'Phased', value: CondominiumType.PHASED, name: 'Phased' },
	{ label: 'Vacant', value: CondominiumType.VACANT, name: 'Vacant' },
	{ label: 'Leasehold', value: CondominiumType.LEASEHOLD, name: 'Leasehold' },
] as const;

export type ResidentialPropertyTypeLabels =
	(typeof propertyTypesResidential)[number]['label'];

export type CommercialPropertyTypeLabels =
	(typeof propertyTypesCommercial)[number]['label'];

export type CondoTypeLabels = (typeof condoTypes)[number]['label'];

export interface PropertyTypeOptions {
	label: string;
	value: PropertyType;
	name: string;
}
